<template>
    <div>
        <!-- class topiclist is used here to show boards within a topic
             class topicresults is used elsewhere to show topic search
             results... the layout is slightly different -->
        <div class="content-container topiclist">
            <div class="header">
                <div class="header-left title">{{ boardName | decodeHtml }}</div>
                <div class="header-right pagination">
                    <Paginator v-if="pageReady" :pageData = "pageData" />
                </div>
            </div>            
            <div class="blocklist-header subtitle columntitles tli">
                <div class="tli-headers">
                    <div class="col-status">Status</div>
                    <div class="col-topic">Topic</div>
                    <!--<div class="col-board">Board</div>-->
                    <div class="col-started-by">Started By</div>
                    <div class="col-replies">Replies</div>
                    <div class="col-views">Views</div>
                    <div class="col-latest">Latest Action</div>
                </div>
            </div>
            <div class="content nopad">                
                <TopicListItem v-for="topic in topics" :key="topic.id" :topic="topic"></TopicListItem>                
            </div>
            <div class="footer">
                <div class="footer-right pagination">
                    <Paginator v-if="pageReady" :pageData = "pageData" />
                </div>
            </div>            
        </div>
    </div>
</template>

<script>

    import TopicListItem from '../../components/Topics/TopicListItem.vue'
    import Paginator from '../../components/Widgets/Paginator.vue'
    import api from '../../api/api'
    import settings from '../../modules/settings'
    import common from '../../modules/common'


    export default {

        props: ['id'],

        data() {
            return {
                pageReady: false,
                topics: null,
                boardName: null,
                pageData: {
                    currentPage: null,
                    pageSize: null,
                    totalItems: null
                }
            }
        },

        components: { 
            TopicListItem,
            Paginator
        },

        methods: {

            getPage: function(pageNumber) {
                
                let pageSize = settings.user.getTopicsPerPage();

                api.get('/boards/' + this.id, {
                    params: {
                        boardID: parseInt(this.id),
                        pageSize: pageSize,
                        requestedPage: pageNumber,
                        sortOrder: 'desc'
                    }
                }).then((response) => {
                    this.topics = response.data.topics;
                    this.boardName = response.data.boardName;

                    var bc = common.breadcrumb.create([
                        { url: '/', text: 'UtterAccess' },
                        { url: '/boards', text: 'Boards' },
                        { url: '/boards/' + this.id, text: this.$options.filters.decodeHtml(this.boardName) },
                    ]);
                    this.$store.dispatch("breadcrumb", bc);
                    
                    this.pageData = {
                        getPage: this.getPage,  
                        currentPage: pageNumber,
                        pageSize: pageSize,
                        totalItems: response.data.topics.length > 0 ? response.data.topics[0].totalRows : 0                        
                    }
                    this.pageReady = true;                    
                });
            }
        },

        mounted() {
            
            var bc = common.breadcrumb.create([
                { url: '/', text: 'UtterAccess' },
                { url: '/boards', text: 'Boards' },
                { url: '/boards/' + this.id, text: this.$options.filters.decodeHtml(this.boardName) },
            ]);
            this.$store.dispatch("breadcrumb", bc);

            this.$store.dispatch('createTopicBoardContextID', this.id);
            
            this.getPage(1);
        },
        beforeRouteLeave(to, from, next) {
            this.$store.dispatch('createTopicBoardContextID', null);
            next();
        }
    }

</script>
